module.exports = __webpack_public_path__ + "img/QH.830c9da2.png";